export default __webpack_public_path__ + "static/media/tarjetas.424a3bae.png";